module.exports = __webpack_public_path__ + "static/media/fr_podcast_default_poster.3cc5c985.svg";